import Cookies from 'js-cookie';

export const CUSTOMER_ZIP_DATA_ID = '_customer_zip_data_id';

/**
 * @param {{zipCode?: string, isBookingAllowed?: boolean}} zipData
 */
export const setZipDataCookie = (zipData = {}) => {
  Cookies.set(CUSTOMER_ZIP_DATA_ID, JSON.stringify(zipData));
};

export const getZipDataCookie = () => {
  const raw = Cookies.get(CUSTOMER_ZIP_DATA_ID);
  return raw ? JSON.parse(raw) : undefined;
};
